(function () {
    const url = new URL(window.location.href);
    
    if (url.pathname.includes("juo")) {
        const styles = document.createElement("style");
        styles.innerHTML = `
        div.footer-wrapper.fix-to-bottom {
            position: static;
        }
        #insta-feed {
            display: none;
        }
        `
        document.body.appendChild(styles);
    }
})()